<template>
  <div class="center">
    <video width="1260" controls autoplay>
      <source src="@/assets/gds.mp4" type="video/mp4" />
      您的浏览器不支持 HTML5 video 标签。
    </video>
  </div>
</template>
<style lang="scss" scoped>
.center {
  text-align: center;
  height: auto;
}
</style>